import * as msal from "@azure/msal-browser";

/**
 * Detect environment based on current URL:
 * - 'prod'  → https://instructor.muic.io/
 * - 'stg'   → https://instructor-stg.muic.io/ (Assumed based on pattern)
 * - 'local' → localhost:8000, 8001, 3000
 */
const getEnvironment = () => {
    const hostname = globalThis.location.hostname;
    const port = globalThis.location.port;

    if (hostname === 'instructor.muic.io') return 'prod';
    if (hostname === 'instructor-stg.muic.io' || hostname === 'instructor-dev.muic.io') return 'stg';

    // localhost or 127.0.0.1 on known dev ports
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        if (['8000', '8001', '3000', '3001'].includes(port)) return 'local';
        return 'local'; // default any localhost to local
    }

    // Fallback to prod for unknown hosts
    return 'prod';
};

const getRedirectUri = () => {
    // If explicit env var is set, use it
    if (process.env.VUE_APP_MSAL_REDIRECT_URI) {
        return process.env.VUE_APP_MSAL_REDIRECT_URI;
    }
    // If running on localhost and no env var, force trailing slash
    // Azure AD commonly registers localhost with a trailing slash
    if (globalThis.location.hostname === 'localhost' || globalThis.location.hostname === '127.0.0.1') {
        return globalThis.location.origin.endsWith('/') ? globalThis.location.origin : globalThis.location.origin + '/';
    }
    return globalThis.location.origin;
}

const env = getEnvironment();
const isLocal = env === 'local';

const msalConfig = {
    auth: {
        clientId: isLocal
            ? "cd589853-e246-4124-a2cc-3b3bb299db78"
            : process.env.VUE_APP_MSAL_CLIENT_ID ||
            "cd589853-e246-4124-a2cc-3b3bb299db78",

        authority: isLocal
            ? "https://login.microsoftonline.com/5a8c21e3-7c52-40e3-8d81-deba37efd8dc"
            : process.env.VUE_APP_MSAL_AUTHORITY ||
            "https://login.microsoftonline.com/5a8c21e3-7c52-40e3-8d81-deba37efd8dc",

        redirectUri: getRedirectUri(),

        postLogoutRedirectUri:
            process.env.VUE_APP_MSAL_POST_LOGOUT_REDIRECT_URI ||
            window.location.origin + "/login",

        navigateToLoginRequestUrl: false,
    },

    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true,
    },

    // ✅ เพิ่มตรงนี้ช่วย timeout popup
    system: {
        windowHashTimeout: 60000,
        iframeHashTimeout: 60000,
    },
};

const MSAL_SCOPES = isLocal
    ? ["api://cd589853-e246-4124-a2cc-3b3bb299db78/instructor-prod"]
    : ["api://cd589853-e246-4124-a2cc-3b3bb299db78/instructor-prod"];

const msalInstance = new msal.PublicClientApplication(msalConfig);

export { msalInstance, MSAL_SCOPES };